import React from "react";
import {Box, Checkbox, Typography,} from "@mui/material";
import {getPerc} from "../svc/Utils";

export default function DpeScale({
                                     scalecolor, text, dpe, changeState, title, dpev1, setDpev1,
                                     setBdnbItem, bdnbItem
                                 }) {
    const [state, setState] = React.useState({
        "A": true,
        "B": true,
        "C": true,
        "D": true,
        "E": true,
        "F": true,
        "G": true
    });

    function getWidth(props, dpeElement, nbDpesV2) {
        let max = 0
        Object.keys(dpe).filter((d) => d != "N").map((d) => {
            if (max < parseInt(dpe[d])) {
                max = parseInt(dpe[d])
            }
        })

        return "calc(" + props + "px * " + (dpeElement) * 1 / (max) + ")";
    }

    const [nbDpesV2, setNbDpesV2] = React.useState(null)


    React.useEffect(() => {
        if (dpe) {
            let total = 0
            Object.keys(dpe).map((d) => {
                total += parseInt(dpe[d])
            })
            setNbDpesV2(total)
        }
    }, [dpe]);

    if (dpe && nbDpesV2) {
        return (
            <Box sx={{width: "20%", ml: 1, mr: 1, mb: 4}}>
                <Box sx={{width: 250, display: "flex", height: 25, alignItems: "center", marginBottom: 1}}>
                    <Typography sx={{
                        width: "100%",
                        textAlign: "center",
                        fontWeight: 800,
                        color: "#fff",
                        backgroundColor: "#1f0d88"
                    }} variant="subtitle1">{title}</Typography>
                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.A} onClick={() => {
                        let tmpState = {...state, A: !state.A};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}

                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.A,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.A}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["A"], nbDpesV2),
                            backgroundColor: scalecolor.A,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["A"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["A"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.B} onClick={() => {
                        let tmpState = {...state, B: !state.B};
                        setState(tmpState)
                        changeState(tmpState);

                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.B,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.B}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["B"], nbDpesV2),
                            backgroundColor: scalecolor.B,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["B"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["B"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.C} onClick={() => {
                        let tmpState = {...state, C: !state.C};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.C,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.C}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["C"], nbDpesV2),
                            backgroundColor: scalecolor.C,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["C"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["C"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.D} onClick={() => {
                        let tmpState = {...state, D: !state.D};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.D,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.D}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["D"], nbDpesV2),
                            backgroundColor: scalecolor.D,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["D"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["D"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.E} onClick={() => {
                        let tmpState = {...state, E: !state.E};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.E,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.E}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["E"], nbDpesV2),
                            backgroundColor: scalecolor.E,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["E"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["E"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.F} onClick={() => {
                        let tmpState = {...state, F: !state.F};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.F,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.F}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["F"], nbDpesV2),
                            backgroundColor: scalecolor.F,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["F"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["F"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.G} onClick={() => {
                        let tmpState = {...state, G: !state.G};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.G,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.G}</Typography>
                    </Box>
                    <Box sx={{
                        width: 195,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(190, dpe["G"], nbDpesV2),
                            backgroundColor: scalecolor.G,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 195,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["G"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["G"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: 2
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={dpev1} onClick={() => {
                        setDpev1(!dpev1)
                    }}/>}
                    <Box sx={{
                        width: 200,

                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        flexDirection: "column"
                    }}>
                        <Typography>DPE non opposables</Typography>
                        <Typography>avant 07/2021</Typography>
                    </Box>


                </Box>
                {bdnbItem!==undefined &&<Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: 2
                }}>
                     <Checkbox sx={{p: 0}} size="small" checked={bdnbItem} onClick={() => {
                        setBdnbItem(!bdnbItem)
                    }}/>
                    <Box sx={{
                        width: 200,

                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        flexDirection: "column"
                    }}>
                        <Typography>BDNB vide</Typography>

                    </Box>


                </Box>}

            </Box>
        )
    }

}

/*
import React from "react";
import {
    Accordion, AccordionDetails, AccordionSummary,
    Box, Button, Checkbox,
    CircularProgress, FormControlLabel, FormGroup, TextField, Tooltip, Typography,

} from "@mui/material";
import DpeCtrl from "../svc/openapi/DpeCtrl";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import TagIcon from '@mui/icons-material/Tag';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import StoreIcon from '@mui/icons-material/Store';
import AirlineSeatFlatIcon from '@mui/icons-material/AirlineSeatFlat';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import HeightIcon from '@mui/icons-material/Height';
import {VictoryPie} from "victory";
import IconMSquare from "../ico/IconMSquare";
import IconMSquare2 from "../ico/IconMSquare2";
import IconPrise from "../ico/IconPrise";
import LineWeightIcon from '@mui/icons-material/LineWeight';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ReactApexCharts from 'react-apexcharts'
import IconMaison from "../ico/IconMagasin";
import {getPerc} from "../svc/Utils";
import PercentIcon from '@mui/icons-material/ArrowRight';

export default function DpeScale({scalecolor, text, dpe, nbDpesV2, changeState, title, chV1, chV2}) {
    const [state, setState] = React.useState({
        "A": true,
        "B": true,
        "C": true,
        "D": true,
        "E": true,
        "F": true,
        "G": true
    });
    if (dpe) {
        return (
            <Box sx={{width: "20%", ml: 1, mr: 1}}>
                <Box sx={{width: 250, display: "flex", height: 25, alignItems: "center"}}>
                    <Typography sx={{width: 180, textAlign: "center"}} variant="subtitle1">{title}</Typography>
                    {chV1}
                    {chV2}
                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.A} onClick={() => {
                        let tmpState = {...state, A: !state.A};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 80, backgroundColor: scalecolor.A, color: "#000"}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.A}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 80, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["A"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["A"]) / (nbDpesV2))}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.B} onClick={() => {
                        let tmpState = {...state, B: !state.B};
                        setState(tmpState)
                        changeState(tmpState);

                    }}/>}
                    <Box sx={{width: 250 - 60 - 75, backgroundColor: scalecolor.B, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.B}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 75, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["B"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["B"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.C} onClick={() => {
                        let tmpState = {...state, C: !state.C};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 70, backgroundColor: scalecolor.C, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.C}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 70, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["C"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["C"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.D} onClick={() => {
                        let tmpState = {...state, D: !state.D};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 65, backgroundColor: scalecolor.D, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.D}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 65, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["D"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["D"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.E} onClick={() => {
                        let tmpState = {...state, E: !state.E};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 60, backgroundColor: scalecolor.E, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.E}</Typography>

                    </Box>
                    <Box
                        sx={{
                            width: 60, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["E"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["E"]) / (nbDpesV2))}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.F} onClick={() => {
                        let tmpState = {...state, F: !state.F};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 55, backgroundColor: scalecolor.F, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.F}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 55, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["F"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["F"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{width: 250, height: 20, display: "flex"}}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.G} onClick={() => {
                        let tmpState = {...state, G: !state.G};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{width: 250 - 60 - 50, backgroundColor: scalecolor.G, color: "#000", fontWeight: 'bold'}}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>{text.G}</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: 50, color: "#000", textAlign: "center"
                        }}></Box>
                    <Box sx={{
                        width: 60, display: "flex", textAlign: "right", fontSize: "0.9em", alignItems: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {dpe["G"]}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", width: "50%"}}>
                            {getPerc((dpe["G"]) / (nbDpesV2))}
                        </Box>
                    </Box>

                </Box>

            </Box>
        )
    }

}

 */
